
import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate  } from 'react-router-dom';

const NotAccessible: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Result status="403" title="403"
      subTitle="Sorry, the page you visited is not accessible."
      extra={<Button type="primary" onClick={() => navigate(-1)}>Back to previous</Button>}
    />
  );
};

export default NotAccessible;
